import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import StarRating from '../../../UIComponents/starRating';
import styles from './RatingStars.module.scss';

const FADE_DURATION = 800;

const RatingStars = ({ selectedAssetAggregatedData }) => {
  const assets = useSelector((state) => state.assets);
  const [isShowStars, setIsShowStars] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    if (assets.inProgress?.changeStars) {
      clearTimeout(hideTimeoutRef.current);

      setIsShowStars(true);

      if (isFirstRender) {
        setIsFirstRender(false);
      }
    } else {
      hideTimeoutRef.current = setTimeout(() => {
        setIsShowStars(false);
      }, FADE_DURATION);
    }

    return () => clearTimeout(hideTimeoutRef.current);
  }, [assets.inProgress?.changeStars, isFirstRender]);

  return (
    <div className={cn(styles.ratingStars, !isFirstRender && styles.ratingStarsFadeOut, isShowStars && styles.ratingStarsShown)}>
      <StarRating value={selectedAssetAggregatedData?.rating} />
    </div>
  );
};

RatingStars.propTypes = {
  selectedAssetAggregatedData: PropTypes.shape({
    rating: PropTypes.number,
  }).isRequired,
};

export default RatingStars;
